import { initializeApp } from 'firebase/app'
import { getAuth, GoogleAuthProvider, OAuthProvider, connectAuthEmulator } from 'firebase/auth'
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore'
import { getStorage, connectStorageEmulator } from 'firebase/storage'
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions'

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID
}

const app = initializeApp(firebaseConfig)

export const auth = getAuth(app)
export const firestore = getFirestore(app)
export const storage = getStorage(app)
export const functions = getFunctions(app)
export const googleProvider = new GoogleAuthProvider()

// Sign in with Apple（App Store審査要件 4.8: ソーシャルログイン提供時はApple SSOも必須）
export const appleProvider = new OAuthProvider('apple.com')
appleProvider.addScope('email')
appleProvider.addScope('name')

// Emulator configuration
const useEmulator = import.meta.env.VITE_USE_EMULATOR === 'true'
const useAuthEmulator = import.meta.env.VITE_USE_AUTH_EMULATOR === 'true'

if (useEmulator) {
  // 認証は本番環境を使用する場合はスキップ
  if (useAuthEmulator) {
    try {
      // Connect to Authentication Emulator
      connectAuthEmulator(auth, import.meta.env.VITE_EMULATOR_AUTH_URL, { disableWarnings: true })
    } catch (error) {
      console.log('Auth emulator already connected or failed to connect:', error)
    }
  }
  
  try {
    // Connect to Firestore Emulator
    connectFirestoreEmulator(
      firestore, 
      import.meta.env.VITE_EMULATOR_FIRESTORE_HOST, 
      parseInt(import.meta.env.VITE_EMULATOR_FIRESTORE_PORT)
    )
  } catch (error) {
    console.log('Firestore emulator already connected or failed to connect:', error)
  }
  
  try {
    // Connect to Storage Emulator
    connectStorageEmulator(
      storage, 
      import.meta.env.VITE_EMULATOR_STORAGE_HOST, 
      parseInt(import.meta.env.VITE_EMULATOR_STORAGE_PORT)
    )
  } catch (error) {
    console.log('Storage emulator already connected or failed to connect:', error)
  }
  
  try {
    // Connect to Functions Emulator
    connectFunctionsEmulator(
      functions, 
      import.meta.env.VITE_EMULATOR_FUNCTIONS_HOST, 
      parseInt(import.meta.env.VITE_EMULATOR_FUNCTIONS_PORT)
    )
  } catch (error) {
    console.log('Functions emulator already connected or failed to connect:', error)
  }
}

export default app